import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

export interface ManageAccessState {
  isOpen: boolean;
  workflowInstanceId: string | null;
}

const initialState: ManageAccessState = {
  isOpen: false,
  workflowInstanceId: null,
};

export const manageAccessSlice = createSlice({
  name: "manageAccess",
  initialState,
  reducers: {
    openManageAccess: (state, action: PayloadAction<{ workflowInstanceId: string }>) => {
      state.isOpen = true;
      state.workflowInstanceId = action.payload.workflowInstanceId;
    },
    closeManageAccess: (state) => {
      state.isOpen = false;
      state.workflowInstanceId = null;
    },
  },
});

export const { openManageAccess, closeManageAccess } = manageAccessSlice.actions;

export function selectIsManageAccessOpen(state: { manageAccess: ManageAccessState }) {
  return state.manageAccess.isOpen;
}

export function selectManageAccessWorkflowInstanceId(state: { manageAccess: ManageAccessState }) {
  return state.manageAccess.workflowInstanceId;
}
